import React from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import pulsar150 from "../../images/pulsar-150.jpg";
import "../../../src/product.css";

const Pulsar150 = () => {
  return (
    <>
      <Header />

      <main className="product-page container text-center">
        {/* Product Hero */}

        <h2 id="title">PULSAR 150cc</h2>

        <section className="product-hero">

          <div className="product-image-wrapper">
            <img
              src={pulsar150}
              alt="Bajaj Pulsar 150cc"
              className="product-image"
            />
          </div>

          <div className="product-info">

            <p>
              A bike that asserts every rider’s passion for biking by bringing
              all the features in this single thrill machine. Pulsar 150 is
              meant for the rider who seeks adventure every day.
            </p>

          </div>
        </section>

        {/* Specifications */}
        <section className="product-specifications">

          <div className="section-heading">
            <span>TECHNICAL DETAILS</span>
            <h2>Specifications</h2>
          </div>

          <div className="spec-grid">

            <div className="spec-card">
              <span>Engine Type</span>
              <strong>4 Stroke Engine</strong>
            </div>

            <div className="spec-card">
              <span>Cubic Capacity</span>
              <strong>149 cc</strong>
            </div>

            <div className="spec-card">
              <span>Transmission</span>
              <strong>Manual</strong>
            </div>

            <div className="spec-card">
              <span>Fuel Type</span>
              <strong>Petrol</strong>
            </div>

            <div className="spec-card">
              <span>Battery</span>
              <strong>12V</strong>
            </div>

            <div className="spec-card">
              <span>Weight</span>
              <strong>143 kg</strong>
            </div>

          </div>
        </section>

      </main>

      <Footer />
    </>
  );
};

export default Pulsar150;
